const CriticalError = () => {
  return <div className="critical-error">Something went wrong. Please try again later.</div>;
};

export default CriticalError;